import { render } from "./cafeItemCard.vue?vue&type=template&id=6f913cec&scoped=true"
import script from "./cafeItemCard.vue?vue&type=script&lang=js"
export * from "./cafeItemCard.vue?vue&type=script&lang=js"

import "./cafeItemCard.vue?vue&type=style&index=0&id=6f913cec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f913cec"]])

export default __exports__